export default __webpack_public_path__ + "static/assets/68a5cea1f9261a6156f891a7fbd7d20b.png";